<template>
    <div>
        <h2>{{translate('integrate_title', integration?.name)}}</h2>
        <p class="mb-3">{{translate('integrate_text1', integration?.name)}}</p>
        <p>{{translate('integrate_text2', integration?.name)}}</p>
        <a :href="link" class="btn btn-primary mt-6">{{translate('probeer_gratis')}}</a>
    </div>
</template>

<script lang="ts">
    import {defineComponent} from 'vue';
    import {Language} from "../../../types/dto/Language";
    import {SoftwarePartner} from "../../../types/dto/SoftwarePartner";
    
    export default defineComponent({
        name: 'integration_no_account',
        props: {
            integration: Object as () => SoftwarePartner,
            language: String as () => Language
        },
        data() {
            return {
                link: '/' + this.language + '/trial/' + this.integration?.integratorCredentials.softwareId
            }
        }
    })
</script>